/**
 * ============================================================================
 * useRetryPostActionMutation — Phase 6c frontend (CCIE).
 * Owner: Claude 3 (Frontend & UX).
 * Purpose: POST /api/v1/changes/{changeId}/post-actions/{actionId}/retry —
 *          re-enqueues a FAILED post-action. The server validates that the
 *          action is in a retryable state and bumps the retry_count.
 * ============================================================================
 */

import { useMutation, type UseMutationResult } from '@tanstack/react-query';
import { apiFetch, newIdempotencyKey } from '../../api/client';
import type { PostAction } from './usePostActionsQuery';

export interface RetryPostActionInput {
  changeId: string;
  actionId: string;
}

export function useRetryPostActionMutation(): UseMutationResult<
  PostAction,
  Error,
  RetryPostActionInput
> {
  return useMutation<PostAction, Error, RetryPostActionInput>({
    mutationFn: ({ changeId, actionId }) =>
      apiFetch<PostAction>(
        `/api/v1/changes/${encodeURIComponent(changeId)}/post-actions/${encodeURIComponent(actionId)}/retry`,
        {
          method: 'POST',
          idempotencyKey: newIdempotencyKey(),
        },
      ),
  });
}
